import { z } from 'zod';
export const CarrierNameEnumSchema = z.enum([
    'American Integrity - Evans Claims',
    'Evans Claims - Staff',
    'Florida Peninsula Insurance',
    'Harbor Claims - Evans Claims',
    'Kin Insurance - Evans Claims Contractor',
    'Kin Insurance - Evans Claims',
    'Patriot Select - Evans Claims',
    'Security First - EIG',
    'TECH - Evans Claims',
    'Universal - Evans Claims',
]);
export const CarrierCodeEnumSchema = z.enum([
    'AII',
    'EIG',
    'EIGT',
    'FPI',
    'HC',
    'KIN',
    'KINC',
    'PS',
    'SFI',
    'UPC',
]);
export const CarrierNameEnum = CarrierNameEnumSchema.enum;
export const CarrierCodeEnum = CarrierCodeEnumSchema.enum;
